import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';
import alertUtil from './alertUtil';
import classList from '../../common/utils/classList';
import Alert, { AlertAttrs } from '../../common/components/Alert';
import PublicizeModal from './PublicizeModal';

export default class SignInModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.results = this.attrs.results
  }

  className() {
    return 'NickameModal Modal--small dl-modal-small';
  }

  title() {
    // return app.translator.trans('dl-person.forum.changeSignNameModal.title');
  }

  view() {
    if (this.alertAttrs) {
      this.alertAttrs.dismissible = false;
    }

    return (
      <div className={classList('Modal modal-dialog fade Modal-sign-container', this.className())}>
        <div className="Modal-sign-content">{this.content()}</div>
      </div>
    );
  }

  content() {
    return (
      <div className="Modal-sign-body">
        <div className="header">
          <div className="title">{app.translator.trans('dl_signInModal.forum.title')}</div>
          {/* <div className="img">
            <img src="${app.data.pkgLogo.cdnUrl}/2024-04-10/1712716881-223194-12.png"></img>
          </div> */}
        <div className="tip">{app.translator.trans('dl_signInModal.forum.add_integra', { addIntegra: this.results?.count_add_integra, addExp: this.results?.count_add_experiences })}</div>
        </div>
        <div className="content">
          {/* <div className="top">已连续签到3天，额外获得1积分</div> */}
          <div className="bottom">{app.translator.trans('dl_signInModal.forum.all_integra', { allIntegra: this.results?.userLevel.all_integra, allExp: this.results?.userLevel.all_experiences })}</div>
        </div>
        <div className="footer">
            {/* <Button className="left-btn">{app.translator.trans('dl_signInModal.forum.my_integer')}</Button> */}
            <Button className="btn" onclick={() => {
              app.modal.close();
              if (app.data.currentIndexWindow && app.data.currentIndexWindow.status) {
                app.modal.show(PublicizeModal);
              }
            }} >{app.translator.trans('dl_signInModal.forum.sure')}</Button>
        </div>
      </div>
    );
  }

}
